"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoViewsInRange = exports.NoViewsYet = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var AnalyticsEmptyState_1 = require("./AnalyticsEmptyState");
var NoViewsYet = function (_a) {
    var pageStatus = _a.pageStatus, isPageEditable = _a.isPageEditable, renderSharePopover = _a.renderSharePopover;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", align: "center", gap: "m" },
        react_1.default.createElement(AnalyticsEmptyState_1.AnalyticsEmptyState, { title: "No views yet", subtitle: noViewsYetMessage(pageStatus, isPageEditable) }),
        (isPageEditable || pageStatus !== Types_1.ProjectStatus.Draft) && (react_1.default.createElement(kaleidoscope_1.Popover, { size: kaleidoscope_1.PopoverSize.Auto, position: kaleidoscope_1.PopoverPosition.Left, offset: 12, button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.Button, __assign({}, buttonProps), "Share"); }, autoStack: true }, renderSharePopover()))));
};
exports.NoViewsYet = NoViewsYet;
function noViewsYetMessage(pageStatus, isPageEditable) {
    if (pageStatus !== Types_1.ProjectStatus.Draft) {
        return "Share this page to start seeing data.";
    }
    if (isPageEditable) {
        return "Set this page live and share to start seeing data.";
    }
    return "";
}
var NoViewsInRange = function () {
    return react_1.default.createElement(AnalyticsEmptyState_1.AnalyticsEmptyState, { title: "No views in this time range" });
};
exports.NoViewsInRange = NoViewsInRange;
